export const environment = {
    production: false,
    url: 'https://api.agende.app.br/api',
}